module.exports = __webpack_public_path__ + "img/bus-side-mdi-green.4113f66c.svg";